import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GUIDES } from './guides';

/* FSC Training index - the list of workflow guides.
 *
 * Exists so /fsc-training is not a duplicate of whichever guide happens to be
 * first. The guides and their routes come from guides.js - add a guide there,
 * not here.
 */

const brand = {
  deepBlue:  '#0a2947',
  tealBlue:  '#0069a6',
  goldenrod: '#d09b2c',
  charcoal:  '#58585b',
  softGray:  '#e9e6e1',
};

export default function FscTrainingIndex() {
  const navigate = useNavigate();

  return (
    <div style={{ background: brand.softGray, minHeight: '100vh', padding: '1.5rem' }}>

      <div style={{ marginBottom: '1.5rem' }}>
        <h4 style={{ color: brand.deepBlue, fontWeight: 800, margin: 0 }}>FSC Training</h4>
        <p style={{ color: brand.charcoal, margin: 0, fontSize: '0.875rem' }}>
          How-to guides for Salesforce Financial Services Cloud
        </p>
      </div>

      {GUIDES.map(group => (
        <div key={group.department} style={{ background: 'white', borderRadius: '12px', boxShadow: '0 2px 12px rgba(10,41,71,0.1)', overflow: 'hidden', marginBottom: '1.5rem' }}>
          <div style={{ background: brand.deepBlue, borderBottom: `3px solid ${brand.goldenrod}`, padding: '0.875rem 1.25rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <i className={`bi bi-${group.icon}`} style={{ color: brand.goldenrod }} />
            <h5 style={{ color: 'white', fontWeight: 700, fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '1px', margin: 0 }}>
              {group.department}
            </h5>
          </div>
          <div style={{ padding: '0.5rem 1.25rem 1rem' }}>
            {group.pages.map(page => (
              <button
                key={page.path}
                onClick={() => navigate(page.path)}
                style={{
                  display: 'flex', alignItems: 'flex-start', gap: '0.75rem', width: '100%',
                  textAlign: 'left', background: 'none', border: 'none',
                  borderBottom: `1px solid ${brand.softGray}`, padding: '0.9rem 0', cursor: 'pointer',
                }}
              >
                <i className={`bi bi-${page.icon}`} style={{ color: brand.tealBlue, fontSize: '1.05rem', paddingTop: '0.1rem' }} />
                <span style={{ flex: '1 1 auto', minWidth: 0 }}>
                  <span style={{ display: 'block', fontWeight: 700, color: brand.deepBlue, fontSize: '0.95rem' }}>
                    {page.label}
                  </span>
                  <span style={{ display: 'block', color: brand.charcoal, fontSize: '0.85rem', marginTop: '0.15rem' }}>
                    {page.blurb}
                  </span>
                </span>
                <i className="bi bi-chevron-right" style={{ color: brand.charcoal, paddingTop: '0.2rem' }} />
              </button>
            ))}
          </div>
        </div>
      ))}

      <p style={{ color: '#7c7c80', fontSize: '0.78rem', maxWidth: '68ch' }}>
        Each guide describes the request form only. They are not tax or compliance advice.
      </p>

    </div>
  );
}
